import React from "react";
import { ProductScreen, Appbar, useMobileMenu } from "../produits/productMobileKit";

export default function AdminMobileShell({ title, subtitle, children }) {
  const onMenu = useMobileMenu();

  return (
    <ProductScreen>
      <Appbar title={title} subtitle={subtitle} onMenu={onMenu} />
      {children}
    </ProductScreen>
  );
}
